import React from "react"
import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { FileInput } from "../inputs/file-input"

interface FileFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof FileInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function FileField<T extends FieldValues>({ field, id, description, ...props }: FileFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <FileInput id={id} error={!!error} {...field} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  visual: File | null;
}

<FormField
  control={form.control}
  name="visual"
  render={({ field }) => (
    <FileField<FormData>
      field={field}
      id="visual"
      label="Visual"
      description="Upload an image or video file"
      accept="image/*,video/*"
    />
  )}
/>
*/
